/**
 * Created by Christal on 2018/5/15.
 * 权限管理
 */
import * as API from './'
import querystring from 'querystring'

export default {
  /**
   * 查找所有的权限
   * @param params
   * @returns {Promise<T | never>}
   */
  findList: params => {
    return API.GET('/api/authority/findList', querystring.stringify(params))
  },
  createOne: params => {
    return API.POST('/api/authority', querystring.stringify(params))
  },
  upDate: params => {
    return API.PUT('/api/authority', querystring.stringify(params))
  },
  delete: params => {
    return API.DELETE('/api/authority', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/api_authority.js